import { render, staticRenderFns } from "./DetailStudentGroupOut.vue?vue&type=template&id=ba507d1a&scoped=true"
import script from "./DetailStudentGroupOut.vue?vue&type=script&lang=js"
export * from "./DetailStudentGroupOut.vue?vue&type=script&lang=js"
import style0 from "./DetailStudentGroupOut.vue?vue&type=style&index=0&id=ba507d1a&lang=css"
import style1 from "./DetailStudentGroupOut.vue?vue&type=style&index=1&id=ba507d1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba507d1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba507d1a')) {
      api.createRecord('ba507d1a', component.options)
    } else {
      api.reload('ba507d1a', component.options)
    }
    module.hot.accept("./DetailStudentGroupOut.vue?vue&type=template&id=ba507d1a&scoped=true", function () {
      api.rerender('ba507d1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupout/DetailStudentGroupOut.vue"
export default component.exports